import React, { useEffect, useState, useNavigate } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import { ic_picture_as_pdf } from 'react-icons-kit/md/ic_picture_as_pdf'
import { ic_info } from 'react-icons-kit/md/ic_info'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrDatePicker from '../components/FrDatePicker'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import download from 'downloadjs'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'
import { mCPF } from '../utils/masks'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Propostas() {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [comboVendedor, setComboVendedor] = useState([{ value: '', display: '' }])
  const [comboStatus, setComboStatus] = useState([{ display: 'A Confirmar', value: 'A' }, { display: 'Cancelada', value: 'C' }, { display: 'Emitida', value: 'E' }, , { display: 'Pendente de Assinatura', value: 'P' }, , { display: 'Assinada', value: 'S' }])
  const [comboPlanos, setComboPlanos] = useState([{ value: '', display: '' }])
  const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [tipoGrupo, setTipoGrupo] = useState('')
  const [nav, setNav] = useState('');  
  let filteredData = ([{PK_PRP: '0'}]);

  const handleRedirect = (e) => {
    console.log(data)
    let auxValues = [...data]
    filteredData = auxValues.filter((element)=>{
      console.log(element.FK_PLA)
      return element.FK_PLA != 43 
    })

    console.log(filteredData)
    // navigate('regProposta')
  }



  const columns = [
    { id: 'NUMERO_PROPOSTA', numeric: true, label: 'Nº Proposta', align: 'left', minWidth: 50 },
    { id: 'RAZAO_SOCIAL', numeric: false, label: 'Proponente', align: 'left', minWidth: 300 },
    { id: 'PLANO_DESCRICAO', numeric: true, label: 'Plano', align: 'left', minWidth: 200 },
    { id: 'PARCEIRO', numeric: true, label: 'Parceiro', align: 'left', minWidth: 200 },
    { id: 'NOMEVENDEDOR', numeric: true, label: 'Vendedor', align: 'left', minWidth: 200 },
    { id: 'STATUS', numeric: true, label: 'Status', align: 'left', minWidth: 200 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setTipoGrupo(await api.getTipoGrupo(auth.user))
      setComboPlanos(await api.getComboData('planos'))
      setComboVendedor(await api.getComboData('vendedores', null, 'pk_uex=' + auth.user))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)
      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    console.log()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    // if (!isEmpty(queryObject)) {
    queryObject.buscar = true
    queryObject.pk_uex = auth.user;
    // queryObject.tipo_grupo =  tipoGrupo;


    setFiltered(true)
    window.history.replaceState({ filtered: true }, 'filter', "/sistema/propostas?" + objectToQueryString(queryObject));
    swal.fire({
      html: <FrLoading text="Buscando dados..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/propostas', { params: queryObject }).then(r => {
      setData(r.data)
      swal.close()
    })
    // } else {
    // swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
    // }
  }

  function clearForm(e) {
    e.preventDefault();
    console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/sistema/propostas');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'cpf':
        auxValues[e.target.name] = mCPF(e.target.value)
        break

      default:
        auxValues[e.target.name] = e.target.value;
        if (typeof (e.target.value) === 'string') auxValues[e.target.name] = e.target.value.toUpperCase()
        break
    }

    setFilter(auxValues);
  };

  function handlePdf(e) {
    e.preventDefault()
    var foundData = false
    swal.fire({
      html: <FrLoading text="Em Processamento..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/termo_adesao?id=0', {responseType: 'blob'}).then(r => {
      let name = 'download.pdf'  
      let type = 'applicaton/pdf'
      if (r.data.size>0){
        foundData=true
      }
      var blob = new Blob([r.data], {
        type: type
        });
        download(blob, name)
        swal.close()
    })
    setTimeout(() => {
      if(!foundData){
        swal.fire({
          title: 'Atenção!',
          text: "arquivo não foi encontrado!",
          icon: 'warning',
        })
      } else {
        swal.close()
      }
    }, 8000)
    // const url = api.backendUrl + '/api/termo_adesao?id=0';
    // var link = document.createElement("a");
    // link.setAttribute('download', 'proposta.pdf');
    // link.href = url;
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
  }

  function chamaApiTeste () {
    api.get('/propostas/verificaAssinaturas').then(r => {
      console.log(r)
    })
  }

  function testJob () {
    api.get('/propostas/teste_job').then(r => {
      console.log(r)
    })
  }

  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h1>Propostas</h1>
          <UserOptions />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.codigo || ''}
                style={{ width: 120 }}
                name="codigo"
                id="codigo"
                color="#49573B"
                label="Proposta"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              <FrDatePicker
                value={(filter.inclusao_inicial || '').split('T')[0]}
                onChange={handleChange}
                name="inclusao_inicial"
                id="inclusao_inicial"
                color="#49573B"
                label="Período Inclusão"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
              />
              <FrDatePicker
                value={(filter.inclusao_final || '').split('T')[0]}
                onChange={handleChange}
                name="inclusao_final"
                id="inclusao_final"
                color="#49573B"
                label=""
                variant="outlined"
                size="small"
                style={{ width: 190 }}
              />
              <FrDatePicker
                value={(filter.vigencia_inicial || '').split('T')[0]}
                onChange={handleChange}
                name="vigencia_inicial"
                id="vigencia_inicial"
                color="#49573B"
                label="Período Vigência"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
              />
              <FrDatePicker
                value={(filter.vigencia_final || '').split('T')[0]}
                onChange={handleChange}
                name="vigencia_final"
                id="vigencia_final"
                color="#49573B"
                label=""
                variant="outlined"
                size="small"
                style={{ width: 190 }}
              />
              <FrSelect
                value={filter.vendedor || ''}
                style={{ width: 210 }}
                name="vendedor"
                id="vendedor"
                label='Vendedor'
                data={comboVendedor}
                onChange={handleChange}
              />
              <FrSelect
                value={filter.status || ''}
                style={{ width: 200 }}
                name="status"
                id="status"
                label='Status'
                data={comboStatus}
                onChange={handleChange}
              />
              <FrSelect
                value={filter.plano || ''}
                style={{ width: 170 }}
                name="plano"
                id="plano"
                label='Plano'
                data={comboPlanos}
                onChange={handleChange}
              />
              <FrTextInput
                value={filter.cpf || ''}
                style={{ width: 140 }}
                name="cpf"
                id="cpf"
                color="#49573B"
                label="CPF"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              <FrTextInput
                value={filter.nome || ''}
                style={{ width: 330 }}
                name="nome"
                id="nome"
                color="#49573B"
                label="Nome do Proponente"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              <FrTextInput
                value={tipoGrupo || ''}
                style={{ width: 330 }}
                name="tipo_grupo"
                id="tipo_grupo"
                color="#49573B"
                label="tipo_grupo"
                variant="outlined"
                size="small"
                onChange={e => { e.preventDefault(); setTipoGrupo(e.target.value) }}
                hidden={true}
              />
            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {/* <button onClick={handleRedirect}>
                Teste
              </button> */}
              <Link to="/sistema/propostas/registro">
                <button>
                  <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button>
              </Link>
              {/* <button onClick={testJob}>
                <Icon icon={ic_delete} size={18} />
                testa job
              </button> */}
              {/* <button onClick={handlePdf}>
                <Icon icon={ic_picture_as_pdf} size={18} />
                Proposta Manual
              </button> */}

              {/* <button onClick={chamaApiTeste}>
                <Icon icon={ic_picture_as_pdf} size={18} />
                Proposta Manual
              </button> */}
              {/* {filteredData.map((element)=>{
                return <>
                <p>{element.PK_PRP}</p>
                <br/>
              </>
              })}

              <p>{filteredData[0].PK_PRP}</p>
              <br/> */}
 
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable propostas regName="propostas" columns={columns} searched={filtered} codeName="PK_PRP" page={'Propostas'} data={data} upload={true} />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Propostas;
